const DOCUMENT = 'UNIT_AGENCIES_';

const actions = {
  CHANGE_PROPERTY: DOCUMENT + 'CHANGE_PROPERTY',
  UPDATE_AGENCIES_REQUEST: DOCUMENT + 'UPDATE_AGENCIES_REQUEST',
  UPDATE_AGENCIES_SUCCESS: DOCUMENT + 'UPDATE_AGENCIES_SUCCESS',
  UPDATE_AGENCIES_ERROR: DOCUMENT + 'UPDATE_AGENCIES_ERROR',
  UPDATE_AGENCIES_VALUE: DOCUMENT + 'UPDATE_AGENCIES_VALUE',

  changeProperty: data => ({
    type: actions.CHANGE_PROPERTY,
    payload: data,
  }),

  updateAgenciesRequest: data => ({
    type: actions.UPDATE_AGENCIES_REQUEST,
    payload: data,
  }),

  updateAgenciesSuccess: () => ({
    type: actions.UPDATE_AGENCIES_SUCCESS,
  }),

  updateAgenciesError: () => ({
    type: actions.UPDATE_AGENCIES_ERROR,
  }),

  updateAgenciesValue: data => ({
    type: actions.UPDATE_AGENCIES_VALUE,
    payload: data,
  }),
};

export default actions;
